import { Home, FileText, ShieldAlert, TrendingUp, Scale, ListChecks, Link2, Clock } from 'lucide-react'

export const MAX_FILE_SIZE_MB = 50
export const MAX_FILE_SIZE    = MAX_FILE_SIZE_MB * 1024 * 1024

export const ACTIVE_STATUSES = new Set(['queued', 'running'])

export const STATUS_GROUPS = ['queued', 'running', 'completed', 'failed']

// SMP jobs never set a platform (no platform-specific rendering), so this
// list -- and the filter built from it -- only ever narrows RAID/TVR rows.
export const PLATFORM_GROUPS = ['orion', 'oracle', 'sfdc']

// Moved out of CompliancePage.jsx so that file could shrink down to state
// and composition -- these are static data, not page logic.
export const TAB = Object.freeze({
  HOME:    'home',
  SMP:     'smp',
  RAID:    'raid',
  TVR:     'tvr',
  OBLIGATION: 'obligation',
  STM:     'stm',
  RTM:     'rtm',
  HISTORY: 'history',
})

export const TABS = [
  { key: TAB.HOME,    label: 'Home',                             Icon: Home },
  { key: TAB.SMP,     label: 'SMP Generation',                   Icon: FileText },
  { key: TAB.RAID,    label: 'RAID Tracker',                     Icon: ShieldAlert },
  { key: TAB.TVR,     label: 'Track Value',                      Icon: TrendingUp },
  { key: TAB.OBLIGATION, label: 'Obligations',                   Icon: Scale },
  { key: TAB.STM,     label: 'Service Traceability Matrix',      Icon: ListChecks },
  { key: TAB.RTM,     label: 'Requirements Traceability Matrix', Icon: Link2 },
  { key: TAB.HISTORY, label: 'Run History',                      Icon: Clock },
]

export const FEATURE_META = {
  [TAB.SMP]: {
    title: 'SMP Generation',
    sub: 'Upload a Statement of Work and the pipeline will extract all relevant fields and populate the SMP template automatically.',
  },
  [TAB.RAID]: {
    title: 'RAID Tracker',
    sub: 'Upload a Statement of Work and the pipeline will identify risks, assumptions, issues and dependencies and populate the RAID tracker automatically.',
  },
  [TAB.TVR]: {
    title: 'Track Value Repository',
    sub: 'Upload a Statement of Work and the pipeline will identify value-add opportunities beyond the contracted scope and populate the TVR tracker automatically.',
  },
  [TAB.OBLIGATION]: {
    title: 'Obligations Tracker',
    sub: 'Upload a Statement of Work and the pipeline will extract every contractual, legal, regulatory and security obligation — with its clause reference, owner, impact and severity.',
  },
  [TAB.STM]: {
    title: 'Service Traceability Matrix',
    sub: 'Upload a Statement of Work and the pipeline will extract every service, SLA, support window, and staffing entry into the Service Traceability Matrix automatically.',
  },
  [TAB.RTM]: {
    title: 'Requirements Traceability Matrix',
    sub: 'Upload a requirements document (.docx) and the pipeline will extract every requirement, traced back to its exact section, into the Requirements Traceability Matrix automatically.',
  },
}
